const sec_Container = document.querySelector('.pricing-comparison-sec');
console.log(sec_Container);

function syncCardContentHeights() {
    const cards = document.querySelectorAll('.card-content');
    if (!cards.length) return;

    cards.forEach(el => { el.style.minHeight = '0px'; });
    const tallest = Math.max(...Array.from(cards, el => el.offsetHeight));
    cards.forEach(el => { el.style.minHeight = `${tallest}px`; });
}

syncCardContentHeights();
window.addEventListener('load', syncCardContentHeights);
window.addEventListener('resize', syncCardContentHeights);
if (document.fonts) {
    document.fonts.ready.then(syncCardContentHeights);
}